import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import '../styles/Download.css';

const Download = () => {
    useEffect(() => {
        document.body.classList.add('download-page-active');
        return () => {
            document.body.classList.remove('download-page-active');
        };
    }, []);

    return (
        <div className="download-page">
            <div className="download-content">
                <div className="container">
                    <div className="download-hero">
                        <div className="hero-lights">
                            <img src="/images/lights.png" alt="Lights" />
                        </div>
                        <div className="hero-app-icon">
                            <img src="/images/app-icon.png" alt="App Icon" />
                        </div>
                        <div className="hero-labels">
                            <label className="label-1">Lights.</label>
                            <label className="label-2">Camera.</label>
                            <label className="label-3">Action.</label>
                        </div>
                        <div className="hero-text">
                            <h1>Download Fiktion</h1>
                            <p>Fiktion is a web-based app that runs in the browser, but you can still download it and feature it in your dock for easy access.
                                <br /><br />
                                Just click the install button in your preferred browser. Either from the Address bar in Chrome, or the File dropdown in Safari.</p>
                            <div className="hero-how-to">
                                <div className="chrome-bar">
                                    <div className="pill">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.35 3.22498H1.875V18.075H21.45V13.35" stroke="white" stroke-width="2.025" />
                                            <path d="M18.0754 2.54993V11.9999M18.0754 11.9999L14.0254 7.94993M18.0754 11.9999L22.1254 7.94993" stroke="white" stroke-width="2.025" />
                                            <rect x="7.95117" y="17.4" width="8.1" height="4.05" fill="white" />
                                        </svg>
                                        <span>Install</span>
                                    </div>
                                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24.4026 7.53754C24.6358 7.53754 24.857 7.62892 25.0229 7.79243C25.1865 7.95354 25.2778 8.16514 25.2778 8.38877V24.4298C25.2778 24.6535 25.1889 24.8651 25.0229 25.0262C24.857 25.1897 24.6358 25.2811 24.4026 25.2811H15.5969L9.81146 7.53754H24.4026ZM24.4026 6.81616H8.81836L15.0727 26.0024H24.4026C25.2802 26.0024 25.9992 25.2955 25.9992 24.4298V8.38877C25.9992 7.52311 25.2802 6.81616 24.4026 6.81616Z" fill="#C7C7C7" />
                                        <path d="M13.5957 21.4698L15.0721 26.0025L19.1768 21.4698H13.5957Z" fill="#C7C7C7" />
                                        <path d="M24.5083 13.4457V12.5055H19.9757V10.9858H18.5041V12.5055H15.6113V13.4457H21.3679C21.0601 14.5302 20.3796 15.5546 19.716 16.3505C18.5401 14.9582 18.5353 14.5062 18.5353 14.5062H17.3138C17.3138 14.5062 17.3643 15.1843 19.0138 17.1176C18.4776 17.6658 18.0712 17.9904 18.0712 17.9904L18.4463 19.1639C18.4463 19.1639 19.0138 18.6757 19.7232 17.9231C20.4349 18.695 21.3535 19.6232 22.5414 20.7293L23.3133 19.9574C22.0412 18.8032 21.1082 17.887 20.4229 17.1512C21.3415 16.0643 22.2745 14.6961 22.4716 13.4433H24.5059V13.4457H24.5083Z" fill="#C7C7C7" />
                                        <path d="M3.59665 1.99744C2.71897 1.99744 2 2.71641 2 3.59649V19.8756C2 20.7533 2.71897 21.4723 3.59665 21.4723H19.1808L12.9265 1.99744H3.59665Z" fill="#C7C7C7" />
                                        <path d="M10.93 12.3516C10.8699 13.0801 10.2471 14.1598 8.73945 14.1598C7.43376 14.1598 6.37573 13.0801 6.37573 11.7504C6.37573 10.4207 7.43376 9.341 8.73945 9.341C9.48247 9.341 9.97782 9.66321 10.2616 9.92531L11.2523 8.97309C10.6006 8.37194 9.75179 7.99683 8.73945 7.99683C6.66909 7.99683 4.98828 9.67764 4.98828 11.748C4.98828 13.8184 6.66909 15.4992 8.73945 15.4992C10.9084 15.4992 12.3415 13.9771 12.3415 11.8298C12.3415 11.522 12.3031 11.2959 12.2526 11.0651H8.74186V12.3491L10.93 12.3516Z" fill="#1D1D1D" />
                                    </svg>
                                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14.7002 5.73047L16.5381 10.5068L21.6484 10.7793L23.5947 10.8828L22.0811 12.1104L18.1064 15.333L19.4268 20.2783L19.9297 22.1611L18.2939 21.1016L14 18.3174L9.70605 21.1016L8.07031 22.1611L8.57324 20.2783L9.89258 15.333L5.91895 12.1104L4.40527 10.8828L6.35156 10.7793L11.4609 10.5068L13.2998 5.73047L14 3.91211L14.7002 5.73047Z" stroke="#D9D9D9" stroke-width="1.5" />
                                    </svg>

                                </div>
                                <span>Chrome</span>
                            </div>
                            <div className="hero-how-to">
                                <div className="safari-dropdown">
                                    <p>Add to Dock</p>
                                </div>
                                <span>Safari</span>
                            </div>
                        </div>
                    </div>
                    <div className="divider"></div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default Download;
